import { createContext } from 'react';
export const FunctionsLoginContext = createContext(() => {});